import type { SimpleStyleT } from "tweenly"
import { PayloadAction } from "@reduxjs/toolkit"
import { ObjectsStateT } from "../../objects.slice"
import { UpdateObjectsStyle } from "./objectTypes"
import { markObjectsUpdated } from "./markObjectsUpdated"

export const updateObjectsLockAspectRationPropertyBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<UpdateObjectsStyle>
) => {
    const { objects, value, property } = action.payload
    objects.forEach((object) => {
        const currentWidth: SimpleStyleT | undefined = object.styles.find(
            (style) => style.property === "width"
        )
        const currentHeight: SimpleStyleT | undefined = object.styles.find(
            (style) => style.property === "height"
        )
        let newWidth: number = 0
        let newHeight: number = 0
        if (property === "width") {
            newWidth = Number(value)
            newHeight = Number(
                Number(
                    (newWidth * Number(currentHeight?.value)) / Number(currentWidth?.value)
                ).toFixed(2)
            )
        } else if (property === "height") {
            newHeight = Number(value)
            newWidth = Number(
                Number(
                    (newHeight * Number(currentWidth?.value)) / Number(currentHeight?.value)
                ).toFixed(2)
            )
        }

        const restStyles = object.styles.filter(
            (style) => style.property !== "width" && style.property !== "height"
        )
        // an object without a height (a line) has no aspect ratio — its width is just set
        if (currentWidth && !currentHeight && property === "width") {
            if (Number(currentWidth.value) !== newWidth) {
                state.value = {
                    ...state.value,
                    [object.id]: {
                        ...object,
                        styles: [...restStyles, { ...currentWidth, value: newWidth }],
                    },
                }
            }
        } else if (currentHeight && currentWidth) {
            const shouldUpdate =
                Number(currentWidth.value) !== newWidth || Number(currentHeight.value) !== newHeight

            if (shouldUpdate) {
                state.value = {
                    ...state.value,
                    [object.id]: {
                        ...object,
                        styles: [
                            ...restStyles,
                            { ...currentWidth, value: newWidth },
                            { ...currentHeight, value: newHeight },
                        ],
                    },
                }
            }
        }
    })
    markObjectsUpdated(state, null)
}
